/* eslint-disable no-unused-vars */

function getLangCode () {
  let langCode = i18next.language.substring(0, 2)
  if (!langCode) {
    langCode = 'en'
  }
  return langCode
}

function getCookie (name) {
  const cookieArr = document.cookie.split(';')
  for (let i = 0; i < cookieArr.length; i++) {
    const cookiePair = cookieArr[i].split('=')
    if (name === cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1])
    }
  }
  return null
}
